"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SearchBox = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _connectors = require("@insided/shared/services/algolia/connectors");

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _SearchInputWithIcons = _interopRequireDefault(require("./SearchInputWithIcons"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SearchBox = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(SearchBox, _Component);

  var _super = _createSuper(SearchBox);

  function SearchBox(props) {
    var _this;

    (0, _classCallCheck2.default)(this, SearchBox);
    _this = _super.call(this, props);
    _this.handleChange = (0, _debounce.default)(_this.handleChange.bind((0, _assertThisInitialized2.default)(_this)), 150);
    return _this;
  }

  (0, _createClass2.default)(SearchBox, [{
    key: "handleChange",
    value: function handleChange(value) {
      this.props.refine(value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          currentRefinement = _this$props.currentRefinement,
          enableLoader = _this$props.enableLoader;
      return (0, _preact.h)(_phrase.default, {
        p: "live.search.placeholder",
        renderAsText: true
      }, function (placeholder) {
        return (0, _preact.h)("div", {
          className: "search-box-wrapper"
        }, (0, _preact.h)(_SearchInputWithIcons.default, {
          initialValue: currentRefinement,
          attributes: {
            type: 'search',
            placeholder: placeholder
          },
          className: "",
          onChange: function onChange(newValue) {
            return _this2.handleChange(newValue);
          },
          loading: enableLoader
        }));
      });
    }
  }]);
  return SearchBox;
}(_preact.Component);

exports.SearchBox = SearchBox;
var InstantSearchBox = (0, _connectors.connectSearchBox)(SearchBox);
var _default = InstantSearchBox;
exports.default = _default;